module.exports = __webpack_public_path__ + "static/img/lazyImg.098e370.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lazyImg.gif
// module id = 53
// module chunks = 1